// @ts-nocheck
import { ElbowBlock } from "../models/resistances/ElbowBlock";
import { Tee } from "../models/resistances/Tee";
import { Block } from "../models/shapes/Block";
import { Line } from "../models/shapes/Line";
import { Branch } from "../models/nets/Branch";
import { isin } from "../shared/common";
import { getDisplayedShapes, getSelectedShapes, a } from "../shared/globalState/a";
import { NetElem, RouteCrucialPoints, Shape, TerminalPath, FlowDirection } from "../shared/types";
import { uid } from "../utils/helpers";
import { Graf } from "../models/nets/GraphExtension";
import { Point } from "../models/Point";
import { s } from "../shared/globalState/settings";
import { getNetworkElementsByNodes, getNetworkLoops, getNetworkLoopsInGraf } from "./graph&network";
import {
    addBidirectionalEdge,
    calculateNodeColor,
    NetworkElement,
    extractNodeIdsWithFittings,
    removeFlowDirectionMarkers,
    mergeGraphNodes,
    mergeGraphEdges
} from "./network/NetworkHelpers";
import { NodeAttributes, CanonicalPoint } from "@models/nets/GraphTypes";

export class GraphRouteManager {
    getSingleRoute(
        currentElement: Line | Block | ElbowBlock | Tee,
        otherElements: Array<Line | Block | ElbowBlock | Tee>,
        visitedElements: Array<string> = []
    ): (Line | Block | ElbowBlock | Tee)[] {
        /**
         * Блоки также являются частью маршрута. Каким-то образом нужно определять не только соединение
         * участка сети с другим участком, но и соединение с другим блоком
         */

        var cecp: RouteCrucialPoints = currentElement.getCrucialPoints();

        // Проверяем, был ли текущий отрезок уже посещен
        if (visitedElements.includes(currentElement.id)) {
            return [];
        }

        // Отмечаем текущий отрезок как посещенный
        visitedElements.push(currentElement.id);

        const connectedElements = otherElements.filter((el: Line | Block | ElbowBlock | Tee) => {
            let oecp: RouteCrucialPoints = el.getCrucialPoints();

            if (oecp.end === undefined) {
                return (
                    isin(cecp.start, oecp.start) ||
                    (cecp.end && isin(cecp.end, oecp.start)) ||
                    (cecp.mid && isin(cecp.mid, oecp.start)) ||
                    isin(cecp.start, oecp.mid) ||
                    (cecp.end && isin(cecp.end, oecp.mid)) ||
                    (cecp.mid && isin(cecp.mid, oecp.mid))
                ) && currentElement.id !== el.id;
            } else {
                return (
                    (isin(cecp.start, oecp.start) ||
                        isin(cecp.start, oecp.end) ||
                        isin(cecp.start, oecp.mid) ||
                        (cecp.mid && isin(cecp.mid, oecp.start)) ||
                        (cecp.mid && isin(cecp.mid, oecp.end)) ||
                        (cecp.mid && isin(cecp.mid, oecp.mid)) ||
                        (cecp.end && isin(cecp.end, oecp.start)) ||
                        (cecp.end && isin(cecp.end, oecp.end)) ||
                        (cecp.end && isin(cecp.end, oecp.mid))) &&
                    currentElement.id !== el.id
                );
            }
        });

        // Рекурсивно ищем пути для каждого найденного отрезка
        const routes = connectedElements.map((cEl) =>
            this.getSingleRoute(cEl, otherElements, [...visitedElements])
        ).flat();

        // Возвращаем текущий отрезок вместе с найденными путями
        return [currentElement].concat(routes);
    }

    /**
 * Основная функция определения маршрутов
 * @param allOrSelected - все элементы или только выбранные
 * @param createGraphs - если true, создаются графовые структуры (по умолчанию true)
 */
    detectRoutes(allOrSelected: boolean, createGraphs: boolean = true) {

        /**
         * При операции копирования скопированные элементы совпадают в точках присоединения с исходными,
         * поэтому определить маршруты взяв все элементы чертежа не получится. Таким образом при операции копирования
         * нужно взять только выбранные элементы и выполнить checkRoute - так можно создать для этих элементов
         * новый маршрут
         */

        if (allOrSelected) {
            var shapesForProcessing = (a.shapes.filter((s: Shape) => s.type !== "guide") as Shape[]);
        }
        else {
            var shapesForProcessing = getSelectedShapes();
        }

        var elementsForRouteCheck = shapesForProcessing.filter((s: Shape) => (s instanceof Line) || (s instanceof ElbowBlock) || (s instanceof Block) || (s instanceof Tee));



        var routeOrRoutes = this.checkRoute(elementsForRouteCheck as (Line | Block | ElbowBlock | Tee)[]);
        console.log(routeOrRoutes);

        this.assignNewNetIdDependingOnNetType(routeOrRoutes);

        // Create graph structures if requested
        if (createGraphs && routeOrRoutes.length > 0) {
            // Normalize to always work with array of arrays
            const networks = Array.isArray(routeOrRoutes[0])
                ? routeOrRoutes as (Line | Block | ElbowBlock | Tee)[][]
                : [routeOrRoutes] as (Line | Block | ElbowBlock | Tee)[][];

            // Create graphs from networks
            const newGraphs = this.createGraphsFromNetworks(networks);

            // Update global state - replace for all shapes, append for selected shapes
            this.updateGlobalGraphState(newGraphs, allOrSelected);

        }
    }

    /**
 * Функция принимает массив отрезков в качестве аргумента
 * и возвращает массив или массив массивов отрезков,
 * принадлежащий к одной сети
 */
    checkRoute(elements: (Line | Block | ElbowBlock | Tee)[]) {

        let networks = [];
        let unprocessedElements = [...elements];


        while (unprocessedElements.length > 0) {
            let currentElement = unprocessedElements[0];
            let route = this.getSingleRoute(currentElement, unprocessedElements);


            // Check for duplicates in route
            const uniqueIds = new Set(route.map(e => e.id));
            if (uniqueIds.size !== route.length) {
            }

            // Исключаем одиночные участки
            if (route.length > 1) {
                networks.push(route);
            }

            // Удаляем из списка необработанных сегментов те, которые вошли в текущий маршрут
            unprocessedElements = unprocessedElements.filter(segment => !route.some(line => line.id === segment.id));
        }

        

        return networks;
    }

    assignNewNetIdDependingOnNetType(networkOrNetworks: NetElem[] | NetElem[][]) {
        if (Array.isArray(networkOrNetworks[0])) {
            (networkOrNetworks as NetElem[][]).forEach((s: Shape[]) => {
                let newNetId = uid.rnd();
                s.forEach((s: NetElem) => s.netId = newNetId);
            });
        }
        else {
            let newNetId = uid.rnd();
            (networkOrNetworks as NetElem[]).forEach((s: NetElem) => {
                s.netId = newNetId;
            });
        }
    }


    private hasSingleBlock(point: CanonicalPoint): boolean {
        if (!('fittings' in point) || !point.fittings) {
            return false;
        }
        const blockArray = point.fittings.filter((f: any) => f.elementKind === 'Block');
        return blockArray.length === 1;
    }

    private buildBaseNodeLabel(point: CanonicalPoint): string {
        const fittingType = point?.fittings?.[0]?.elementKind ?? '__';
        return `${point.id} ${fittingType}`;
    }

    private findLineElementByCanonicalPoint(
        canPoint: CanonicalPoint,
        route: (Line | Block | ElbowBlock | Tee)[]
    ): Line | Block | ElbowBlock | Tee | undefined {
        return route.find((element) => {
            const crucialPoints = element.getCrucialPointsArray();
            return crucialPoints.some((crucialPoint) => crucialPoint.id === canPoint.id);
        });
    }

    private findBlockOrFittingElementByCanonicalPoint(canPoint: CanonicalPoint, route: (Line | Block | ElbowBlock | Tee)[]) {
        const fitting = canPoint.fittings[0];
        
        if (!fitting) {
            return null;
        }
        const childNodeId = fitting.childNodeId;
        return route.find((element) => {
            const crucialPoints = element.getCrucialPointsArray();
            return crucialPoints.some((crucialPoint)=> crucialPoint.id === childNodeId);
        })
    }

    /**
     * Checks if the route contains at least one Block with valid isTerminal and flowDirection properties
     * @param route - Array of network elements
     * @returns true if at least one valid terminal block is found
     */
    private hasValidTerminalBlock(route: (Line | Block | ElbowBlock | Tee)[]): boolean {
        return route.some((element) => {
            if (!(element instanceof Block)) return false;
            const isTerminal = Object.values(element.isTerminal).some(
                isTerminal => isTerminal === true
            );
            const flowDirection = Object.values(element.flowDirections).find(
                direction => direction !== FlowDirection.UNKNOWN
            );
            return isTerminal && flowDirection;
        });
    }

    /**
     * Строит полную графовую структуру из связанного маршрута элементов сети.
     * 
     * Эта функция преобразует коллекцию элементов сети (Линии, Блоки, Отводы, Тройники)
     * в графовое представление с узлами и рёбрами, назначает направления потоков по всей сети
     * и обновляет метки узлов для отображения информации о потоке.
     * 
     * Обзор процесса:
     * 1. Проверяет наличие терминальных блоков в маршруте (необходимо для определения направления потока)
     * 2. Собирает и группирует ключевые точки из всех элементов маршрута
     * 3. Создаёт канонические точки (объединённые точки в одном месте)
     * 4. Строит узлы графа: терминалы, открытые концы и промежуточные узлы
     * 5. Соединяет узлы рёбрами на основе связей элементов маршрута
     * 6. Назначает направления потоков, начиная с терминалов и открытых концов
     * 7. Обновляет метки для отображения информации о направлении потока
     * 
     * @param route - Массив связанных элементов сети (Lines, Blocks, ElbowBlocks, Tees)
     * @returns Graf - Полная графовая структура с узлами, рёбрами и направлениями потоков
     */
    buildGraphFromConnectedRoute(route: (Line | Block | ElbowBlock | Tee)[]): Graf {
        // ============================================
        // ИНИЦИАЛИЗАЦИЯ ГРАФА И ПОДГОТОВКА МАРШРУТА
        // ============================================
        // Создаём новый пустой граф, который будет содержать структуру сети
        const graf = new Graf();
        
        // Удаляем дублирующиеся элементы из маршрута (один и тот же ID элемента встречается несколько раз)
        // Это гарантирует, что мы обработаем каждый уникальный элемент сети только один раз
        const uniqueRoute = this.prepareRouteElements(route);
        
        // ============================================
        // ПРОВЕРКА НАЛИЧИЯ ТЕРМИНАЛЬНЫХ БЛОКОВ
        // ============================================
        /**
         * Если сеть не имеет блоков со свойствами isTerminal и flowDirection - 
         * дальнейшая работа функции не имеет смысла - всё равно не удастся определить 
         * направления потоков
         */
        // Терминальные блоки (например, диффузоры, решётки) необходимы - они определяют начальное
        // направление потока. Без них мы не сможем определить направления потоков в сети.
        // Досрочный выход, если не найдено валидных терминалов.
        if (!this.hasValidTerminalBlock(uniqueRoute)) {
            console.log('⚠️ Нет валидных терминальных блоков, возвращаем пустой граф');
            return graf;
        }
        
        // ============================================
        // СБОР И ОБРАБОТКА КЛЮЧЕВЫХ ТОЧЕК
        // ============================================
        // Шаг 1: Извлекаем все ключевые точки (начало, конец, середина) из каждого элемента маршрута
        // Эти точки представляют точки соединения, где встречаются элементы
        const points = this.collectCrucialPoints(uniqueRoute);
        
        // Шаг 2: Группируем точки, которые находятся в одном физическом месте
        // Несколько элементов могут соединяться в одной точке (например, соединения через тройник)
        const pointGroups = this.groupPointsByLocation(points);
        
        // Шаг 3: Создаём канонические точки - объединяем сгруппированные точки в единые узлы
        // Каждая каноническая точка представляет уникальное местоположение в сети
        const canonicalPoints = this.createCanonicalPoints(pointGroups);

        // ============================================
        // ПОСТРОЕНИЕ УЗЛОВ ГРАФА (с начальными метками)
        // ============================================
        // Разделяем канонические точки на две категории:
        // - blockPoints: Точки, которые имеют один элемент Block (потенциальные терминалы)
        // - otherPoints: Все остальные точки (открытые концы, арматура, обычные соединения)
        const blockPoints: CanonicalPoint[] = [];
        const otherPoints: CanonicalPoint[] = [];

        canonicalPoints.forEach((point: CanonicalPoint) => {
            if (this.hasSingleBlock(point)) {
                blockPoints.push(point);
            } else {
                otherPoints.push(point);
            }
        });

        // Массив для сбора всех атрибутов узлов перед добавлением их в граф
        let nodesToAdd:NodeAttributes[] = [];

        // ============================================
        // ОБРАБОТКА ТОЧЕК С БЛОКАМИ (ТЕРМИНАЛЫ)
        // ============================================
        // Обрабатываем точки, которые имеют элементы Block - это могут быть терминальные узлы или промежуточные узлы
        blockPoints.forEach((canPoint: CanonicalPoint) => {
            // Находим элемент Block, связанный с этой канонической точкой
            const element = this.findBlockOrFittingElementByCanonicalPoint(canPoint, uniqueRoute);
            if (!element || !(element instanceof Block)) {
                return; // Пропускаем, если элемент не найден или не является Block
            }
            
            // Проверяем, помечен ли этот Block как терминал (свойство isTerminal установлено в true)
            const isTerminal = Object.values(element.isTerminal).find(
                isTerminal => isTerminal === true
            );
            
            // Получаем направление потока из свойств Block (IN, OUT или UNKNOWN)
            const flowDirection = Object.values(element.flowDirections).find(
                direction => direction !== FlowDirection.UNKNOWN
            );
            
            /**
             * терминалами являются только конечные блоки - диффузоры, решётки и так далее
             * Направление потока flowDirection - это предопределённое свойство, назначается при создании объектов из symbols
             */
            // Создаём терминальные узлы только если выполнены оба условия:
            // 1. Block помечен как терминал (isTerminal === true)
            // 2. Block имеет валидное направление потока (не UNKNOWN)
            // Терминалы - это конечные устройства, такие как диффузоры, решётки и т.д.
            // Направление потока предопределено при создании объектов из символов
            if (isTerminal && flowDirection) {
                // Строим полную метку с информацией о терминале: baseLabel + [in/out] + [T]
                let fullTerminalLabel = this.buildTerminalNodeFullLabel(canPoint, flowDirection, true);
                
                // Создаём атрибуты узла со свойствами терминала
                const nodeAttrs: NodeAttributes = this.createTerminalNodeAttrs(canPoint, fullTerminalLabel, flowDirection)
                nodesToAdd.push(nodeAttrs);
            } else {
                // Non-terminal blocks should still create intermediate nodes
                // This ensures blocks are included in the graph even if they're not terminals
                const baseLabel = this.buildBaseNodeLabel(canPoint);
                const nodeAttrs: NodeAttributes = this.createOtherNodeAttrs(canPoint, baseLabel);
                nodesToAdd.push(nodeAttrs);
            }
        });

        // ============================================
        // ОБРАБОТКА ОСТАЛЬНЫХ ТОЧЕК (ОТКРЫТЫЕ КОНЦЫ И ПРОМЕЖУТОЧНЫЕ)
        // ============================================
        // Обрабатываем все точки без блоков: это либо открытые концы, либо промежуточные узлы
        otherPoints.forEach((canPoint: CanonicalPoint) => {
            /**
             * Для начала найдём открытые концы. Если у точки не атрибута fittings - значит это открытый конец
             */
            // Определяем, является ли это открытым концом (нет присоединённой арматуры)
            // Открытые концы - это конечные точки сети, где поток входит или выходит
            const isOpenEnd = !canPoint.fittings || canPoint.fittings.length === 0;
            
            if (isOpenEnd) {
                // Создаём узел открытого конца с базовой меткой
                // Направление потока будет назначено позже на основе направления потока терминала
                const baseLabel = this.buildBaseNodeLabel(canPoint);
                const nodeAttrs: NodeAttributes = this.createOpenEndNodeAttrs(canPoint, baseLabel)
                nodesToAdd.push(nodeAttrs);
            }
            else {
                // Создаём промежуточный узел (имеет арматуру, не терминал, не открытый конец)
                // Это точки соединения между элементами сети
                const baseLabel = this.buildBaseNodeLabel(canPoint);
                const nodeAttrs: NodeAttributes = this.createOtherNodeAttrs(canPoint, baseLabel)
                nodesToAdd.push(nodeAttrs);
            }

        });

        // ============================================
        // ДОБАВЛЕНИЕ УЗЛОВ В ГРАФ
        // ============================================
        // Добавляем все собранные узлы в граф с их атрибутами
        // Каждый узел получает: позицию (x, y), метку, флаги типа, размер, цвет, направление потока
        nodesToAdd.forEach(nodeAndAttrs => {
            this.addNodeToGraph(graf, nodeAndAttrs);
        })
        
        // ============================================
        // ПОСТРОЕНИЕ РЁБЕР ГРАФА (СОЕДИНЕНИЯ)
        // ============================================
        // Создаём рёбра между узлами на основе соединений элементов маршрута
        // Рёбра представляют физические соединения между элементами сети
        // Для Линий: соединяет начало ↔ конец
        // Для Отводов: соединяет начало ↔ конец
        // Для Тройников: соединяет base1 ↔ base2 и base1 ↔ side
        // Для Блоков: соединяет cp1 ↔ cp2
        this.buildGraphEdges(graf, uniqueRoute, canonicalPoints);
        
        // ============================================
        // НАЗНАЧЕНИЕ НАПРАВЛЕНИЯ ПОТОКА В ГРАФЕ
        // ============================================
        // Это основной алгоритм назначения направления потока:
        // 1. Устанавливает направления потоков открытых концов в соответствии с направлениями терминалов в каждом цикле
        // 2. Обходит каждый цикл, начиная с открытых концов
        // 3. Распространяет направление потока через узлы арматуры, меняя направление на каждом узле
        //    (IN → OUT → IN → OUT ...)
        // Направление потока чередуется при прохождении через каждую точку арматуры/соединения
        this.assignFlowDirectionInGraf(graf);
        
        // ============================================
        // ОБНОВЛЕНИЕ МЕТОК НА ОСНОВЕ НАПРАВЛЕНИЯ ПОТОКА
        // ============================================
        // После assignFlowDirectionInGraf атрибут flowDirection установлен для всех узлов.
        // Обновляем все метки узлов в соответствии с их атрибутом flowDirection.
        // Мы не можем сделать это ранее, так как направления потоков не указаны
        // 
        // Обновляет метки промежуточных узлов (не терминалы, не открытые концы) для включения
        // маркеров направления потока: [in] или [out]
        // Терминалы уже имеют направление потока в своих метках с момента создания
        // Открытые концы получают обновлённые метки в assignFlowDirectionInGraf
        this.updateIntermediateNodeLabelsWithFlowDirections(graf);

        // ============================================
        // ОТЛАДОЧНЫЙ ВЫВОД
        // ============================================
        // Выводим все узлы с их атрибутами для отладки
        // Показывает: ID узла, родительские/дочерние ID, метку, isTerminal, isOpenEnd, flowDirection
        // graf.printNodesWithAttributes();

        return graf;
    }

    /**
     * Adds a node to the graph with all its attributes
     * @param graf - The graph to add the node to
     * @param nodeAttrs - Node attributes to set
     */
    private addNodeToGraph(graf: Graf, nodeAttrs: NodeAttributes): void {
        const point = new Point(nodeAttrs.x, nodeAttrs.y);
        point.id = nodeAttrs.nodeId;
        graf.mergeNode(point);
        
        // Set all node attributes
        graf.setNodeAttribute(nodeAttrs.nodeId, 'label', nodeAttrs.label);
        graf.setNodeAttribute(nodeAttrs.nodeId, 'isTerminal', nodeAttrs.isTerminal);
        graf.setNodeAttribute(nodeAttrs.nodeId, 'isOpenEnd', nodeAttrs.isOpenEnd);
        graf.setNodeAttribute(nodeAttrs.nodeId, 'size', nodeAttrs.size);
        graf.setNodeAttribute(nodeAttrs.nodeId, 'color', nodeAttrs.color);
        graf.setNodeAttribute(nodeAttrs.nodeId, 'flowDirection', nodeAttrs.flowDirection);
        
        if (nodeAttrs.elementKind) {
            graf.setNodeAttribute(nodeAttrs.nodeId, 'elementKind', nodeAttrs.elementKind);
        }
        if (nodeAttrs.fittings) {
            graf.setNodeAttribute(nodeAttrs.nodeId, 'fittings', nodeAttrs.fittings);
        }
    }

    private createOtherNodeAttrs(canPoint: CanonicalPoint, baseLabel: string): NodeAttributes {
        return {
            nodeId: canPoint.id,
            x: canPoint.x,
            y: canPoint.y,
            elementKind: canPoint.elementKind,
            fittings: canPoint.fittings,
            label: baseLabel,
            isTerminal: false,
            isOpenEnd: false,
            size: 4,
            color: calculateNodeColor(null, false),
            flowDirection: FlowDirection.UNKNOWN
        };
    }

    private createOpenEndNodeAttrs(canPoint: CanonicalPoint, baseLabel: string): NodeAttributes {
        return {
            nodeId: canPoint.id,
            x: canPoint.x,
            y: canPoint.y,
            elementKind: 'Open End',
            fittings: null,
            label: baseLabel,
            isTerminal: false,
            isOpenEnd: true,
            size: 5,
            color: calculateNodeColor(null, false),
            flowDirection: FlowDirection.UNKNOWN
        };
    }

    private createTerminalNodeAttrs(canPoint: CanonicalPoint, fullTerminalLabel: string, flowDirection: FlowDirection): NodeAttributes {
        return {
            nodeId: canPoint.id,
            x: canPoint.x,
            y: canPoint.y,
            elementKind: canPoint.elementKind,
            fittings: canPoint.fittings,
            label: fullTerminalLabel,
            isTerminal: true,
            isOpenEnd: false,
            size: 5,
            color: calculateNodeColor(flowDirection, true),
            flowDirection: flowDirection
        };
    }

    private buildTerminalNodeFullLabel(canPoint: CanonicalPoint, flowDirection: FlowDirection, isTerminal: boolean) {
        let baseLabel = this.buildBaseNodeLabel(canPoint);
        let fullTerminalLabel = this.upgradeBaseNodeLabelWithTerminalInfo(baseLabel, flowDirection, isTerminal);
        return fullTerminalLabel;
    }

    upgradeBaseNodeLabelWithTerminalInfo(baseLabel: string, flowDirection: FlowDirection, isTerminal: boolean): string | null {
        const fdLab = flowDirection === FlowDirection.IN ? '[in]'
            : flowDirection === FlowDirection.OUT ? '[out]'
                : null;
        if (!fdLab) {
            return null;
        }
        let isT = isTerminal ? '[T]' : '';
        let label = baseLabel + ` ${fdLab}` + ` ${isT}`;
        return label;
    }

    /**
     * Updates labels for open ends with flow direction
     * @param graf - The graph
     */
    private updateOpenEndLabelsWithFlowDirections(graf: Graf) {
        graf.nodes().forEach(nodeId => {
            const isOpenEnd = graf.getNodeAttribute(nodeId, 'isOpenEnd');
            
            // Only process open ends
            if (isOpenEnd !== true) {
                return;
            }
            
            // Get current label and flow direction
            const currentLabel = graf.getNodeAttribute(nodeId, 'label') || '';
            const flowDirection = graf.getNodeAttribute(nodeId, 'flowDirection');
            
            // Remove existing flow direction markers
            const baseLabel = removeFlowDirectionMarkers(currentLabel);
            
            // Add flow direction marker if available
            let updatedLabel = baseLabel;
            if (flowDirection === FlowDirection.IN) {
                updatedLabel = `${baseLabel} [in]`;
            } else if (flowDirection === FlowDirection.OUT) {
                updatedLabel = `${baseLabel} [out]`;
            }
            
            // Update node label
            graf.setNodeAttribute(nodeId, 'label', updatedLabel);
        });
    }

    /**
     * Updates labels for intermediate nodes (not terminals, not open ends) with flow direction
     * @param graf - The graph
     */
    updateIntermediateNodeLabelsWithFlowDirections(graf: Graf) {
        graf.nodes().forEach(nodeId => {
            const isTerminal = graf.getNodeAttribute(nodeId, 'isTerminal');
            const isOpenEnd = graf.getNodeAttribute(nodeId, 'isOpenEnd');
            
            // Skip terminals and open ends
            if (isTerminal === true || isOpenEnd === true) {
                return;
            }
            
            // Get current label and flow direction
            const currentLabel = graf.getNodeAttribute(nodeId, 'label') || '';
            const flowDirection = graf.getNodeAttribute(nodeId, 'flowDirection');
            
            // Remove existing flow direction markers
            const baseLabel = removeFlowDirectionMarkers(currentLabel);
            
            // Add flow direction marker if available
            let updatedLabel = baseLabel;
            if (flowDirection === FlowDirection.IN) {
                updatedLabel = `${baseLabel} [in]`;
            } else if (flowDirection === FlowDirection.OUT) {
                updatedLabel = `${baseLabel} [out]`;
            }
            
            // Update node label
            graf.setNodeAttribute(nodeId, 'label', updatedLabel);
        });
    }

    /**
     * Removes duplicate elements from route by element ID
     * @param route - Array of network elements
     * @returns Array of unique elements
     */
    private prepareRouteElements(route: (Line | Block | ElbowBlock | Tee)[]): (Line | Block | ElbowBlock | Tee)[] {
        return route.filter((element, index, self) =>
            index === self.findIndex(e => e.id === element.id)
        );
    }

    /**
     * Collects all crucial points (start, end, mid) from route elements
     * @param route - Array of unique network elements
     * @returns Array of points with element type information
     */
    private collectCrucialPoints(route: (Line | Block | ElbowBlock | Tee)[]): Array<Point & { elementKind: string }> {
        return route.flatMap((element: Line | Block | ElbowBlock | Tee) => {
            const elementKind = element.constructor.name;
            const crucialPoints = element.getCrucialPoints();
            const result: Array<Point & { elementKind: string }> = [];

            if (crucialPoints.start) {
                const point = crucialPoints.start as Point & { elementKind: string };
                point.elementKind = elementKind;
                result.push(point);
            }

            if (crucialPoints.mid) {
                const point = crucialPoints.mid as Point & { elementKind: string };
                point.elementKind = elementKind;
                result.push(point);
            }

            if (crucialPoints.end) {
                const point = crucialPoints.end as Point & { elementKind: string };
                point.elementKind = elementKind;
                result.push(point);
            }

            return result;
        });
    }

    /**
     * Groups points that are at the same location (using isin() comparison)
     * @param points - Array of points to group
     * @returns Array of point groups, where each group contains points at same location
     */
    private groupPointsByLocation(points: Array<Point & { elementKind: string }>): Array<Array<Point & { elementKind: string }>> {
        const pointGroups: Array<Array<Point & { elementKind: string }>> = [];
        const processedIndices = new Set<number>();

        points.forEach((point, index) => {
            if (processedIndices.has(index)) return;

            const group: Array<Point & { elementKind: string }> = [point];
            processedIndices.add(index);

            // Find all other points at the same location
            for (let i = index + 1; i < points.length; i++) {
                if (processedIndices.has(i)) continue;

                if (isin(point, points[i])) {
                    group.push(points[i]);
                    processedIndices.add(i);
                }
            }

            pointGroups.push(group);
        });

        return pointGroups;
    }

    /**
     * Creates canonical points from point groups, prioritizing Line points
     * If multiple points are at the same location, Line points take precedence
     * and other points (fittings, blocks) are stored as metadata
     * @param pointGroups - Array of point groups (points at same location)
     * @returns Array of canonical points with fitting metadata
     */
    private createCanonicalPoints(
        pointGroups: Array<Array<Point & { elementKind: string }>>
    ): CanonicalPoint[] {
        const canonicalPoints: CanonicalPoint[] = [];

        pointGroups.forEach((pointsAtLocation) => {
            if (pointsAtLocation.length === 1) {
                // Single point at this location - add it directly
                const point = pointsAtLocation[0] as CanonicalPoint;
                canonicalPoints.push(point);
            } else {
                // Multiple points at same location - find Line point or use first
                const linePoint = pointsAtLocation.find(p => p.elementKind === 'Line');

                if (linePoint) {
                    // Line point exists - use it as canonical
                    const canonical = linePoint as CanonicalPoint;
                    const otherPoints = pointsAtLocation.filter(p => p.id !== linePoint.id);

                    if (otherPoints.length > 0) {
                        canonical.fittings = otherPoints.map(p => ({
                            childNodeId: p.id,
                            elementKind: p.elementKind,
                            x: p.x,
                            y: p.y
                        }));
                    }

                    canonicalPoints.push(canonical);
                } else {
                    // No Line point - use first point (block or fitting)
                    const canonical = pointsAtLocation[0] as CanonicalPoint;
                    const otherPoints = pointsAtLocation.slice(1);

                    if (otherPoints.length > 0) {
                        canonical.fittings = otherPoints.map(p => ({
                            childNodeId: p.id,
                            elementKind: p.elementKind,
                            x: p.x,
                            y: p.y
                        }));
                    }

                    canonicalPoints.push(canonical);
                }
            }
        });

        return canonicalPoints;
    }

    /**
     * Builds graph edges from route elements
     * @param graf - Graph to add edges to
     * @param uniqueRoute - Array of unique route elements
     * @param canonicalPoints - Array of canonical points (for finding nodes)
     */
    private buildGraphEdges(
        graf: Graf,
        uniqueRoute: (Line | Block | ElbowBlock | Tee)[],
        canonicalPoints: CanonicalPoint[]
    ): void {
        uniqueRoute.forEach((element: Line | Block | ElbowBlock | Tee) => {
            const crucialPoints = element.getCrucialPoints();

            if (element instanceof Line) {
                this.addLineEdges(graf, crucialPoints, canonicalPoints);
            } else if (element instanceof ElbowBlock) {
                this.addElbowBlockEdges(graf, crucialPoints, canonicalPoints);
            } else if (element instanceof Tee) {
                this.addTeeEdges(graf, crucialPoints, canonicalPoints);
            } else if (element instanceof Block) {
                this.addBlockEdges(graf, crucialPoints, canonicalPoints);
            }
        });
    }

    /**
     * Adds edges for a Line element (start ↔ end)
     */
    private addLineEdges(
        graf: Graf,
        crucialPoints: RouteCrucialPoints,
        canonicalPoints: CanonicalPoint[]
    ): void {
        if (crucialPoints.start && crucialPoints.end) {
            const startNode = canonicalPoints.find(p => isin(p, crucialPoints.start));
            const endNode = canonicalPoints.find(p => isin(p, crucialPoints.end));

            if (startNode && endNode) {
                addBidirectionalEdge(graf, startNode, endNode);
            }
        }
    }

    /**
     * Adds edges for an ElbowBlock element (start ↔ end)
     */
    private addElbowBlockEdges(
        graf: Graf,
        crucialPoints: RouteCrucialPoints,
        canonicalPoints: CanonicalPoint[]
    ): void {
        if (crucialPoints.start && crucialPoints.end) {
            const baseNode = canonicalPoints.find(p => isin(p, crucialPoints.start));
            const sideNode = canonicalPoints.find(p => isin(p, crucialPoints.end));

            if (baseNode && sideNode) {
                addBidirectionalEdge(graf, baseNode, sideNode);
            }
        }
    }

    /**
     * Adds edges for a Tee element (base1 ↔ base2, base1 ↔ side, base2 ↔ side)
     */
    private addTeeEdges(
        graf: Graf,
        crucialPoints: RouteCrucialPoints,
        canonicalPoints: CanonicalPoint[]
    ): void {
        if (crucialPoints.start && crucialPoints.end && crucialPoints.mid) {
            const base1Node = canonicalPoints.find(p => isin(p, crucialPoints.start));
            const base2Node = canonicalPoints.find(p => isin(p, crucialPoints.end));
            const sideNode = canonicalPoints.find(p => isin(p, crucialPoints.mid));

            // Connect base1 ↔ base2 (main duct through-flow)
            if (base1Node && base2Node) {
                addBidirectionalEdge(graf, base1Node, base2Node);
            }

            // Connect base1 ↔ side (branch connection)
            if (sideNode && base1Node) {
                addBidirectionalEdge(graf, base1Node, sideNode);
            }

            // Connect base2 ↔ side (branch connection)
            if (sideNode && base2Node) {
                addBidirectionalEdge(graf, base2Node, sideNode);
            }
        }
    }

    /**
     * Adds edges for a Block element (cp1 ↔ cp2)
     */
    private addBlockEdges(
        graf: Graf,
        crucialPoints: RouteCrucialPoints,
        canonicalPoints: CanonicalPoint[]
    ): void {
        if (crucialPoints.start && crucialPoints.end) {
            const cp1Node = canonicalPoints.find(p => isin(p, crucialPoints.start));
            const cp2Node = canonicalPoints.find(p => isin(p, crucialPoints.end));

            if (cp1Node && cp2Node) {
                addBidirectionalEdge(graf, cp1Node, cp2Node);
            }
        }
    }


    /**
     * Создает графовые структуры из обнаруженных маршрутов
     * @param networks - Массив сетей (маршрутов)
     * @returns Массив созданных объектов Graf
     */
    createGraphsFromNetworks(networks: (Line | Block | ElbowBlock | Tee)[][]): Graf[] {

        const graphs: Graf[] = [];

        networks.forEach(route => {
            const graf = this.buildGraphFromConnectedRoute(route);
            graphs.push(graf);
        });

        console.log(graphs[0].nodes());

        return graphs;
    }

    /**
     * Обновляет глобальное состояние графов с новыми созданными графами
     * @param newGraphs - Массив объектов Graf для добавления в глобальное состояние
     * @param replaceExisting - Если true, заменяет все существующие графы; если false, добавляет новые графы
     */
    updateGlobalGraphState(newGraphs: Graf[], replaceExisting: boolean = false): void {
        let graphsToUse: Graf[] = [];
        
        if (replaceExisting) {
            graphsToUse = newGraphs;
        } else {
            // Добавить новые графы к существующим
            graphsToUse = [...a.graphs, ...newGraphs];
        }

        // Merge graphs that share nodes (important after zoom/pan when coordinate precision might cause separate graphs)
        const mergedGraphs = this.mergeConnectedGraphs(graphsToUse);
        
        a.graphs = mergedGraphs;

        // Уведомить подписчиков об изменении
        a.graph$.next(a.graphs);
    }

    /**
     * Merges graphs that share common nodes
     * This is important after zoom/pan operations when coordinate precision issues
     * might cause connected networks to be split into separate graphs
     * @param graphs - Array of graphs to merge
     * @returns Array of merged graphs
     */
    private mergeConnectedGraphs(graphs: Graf[]): Graf[] {
        if (graphs.length <= 1) {
            return graphs;
        }

        const merged: Graf[] = [];
        const processed = new Set<number>();

        for (let i = 0; i < graphs.length; i++) {
            if (processed.has(i)) continue;

            const currentGraph = graphs[i];
            let mergedGraph = currentGraph;

            // Look for other graphs that share nodes with current graph
            for (let j = i + 1; j < graphs.length; j++) {
                if (processed.has(j)) continue;

                const otherGraph = graphs[j];
                
                // Check if graphs share any nodes
                const currentNodes = new Set(mergedGraph.nodes());
                const otherNodes = otherGraph.nodes();
                const hasSharedNodes = otherNodes.some(nodeId => currentNodes.has(nodeId));

                if (hasSharedNodes) {
                    // Merge otherGraph into mergedGraph
                    mergeGraphNodes(mergedGraph, otherGraph);
                    mergeGraphEdges(mergedGraph, otherGraph);
                    processed.add(j);
                }
            }

            merged.push(mergedGraph);
            processed.add(i);
        }

        return merged;
    }

    getNetworkBranches(
        terminalPaths: string[][],
        selectedElements: (Line | Block | ElbowBlock | Tee)[]
    ): Branch[] {

        let branches: Branch[] = [];

        terminalPaths?.forEach((terminalPath: string[], index: number) => {
            let path = terminalPath;

            // Skip if path is undefined or empty
            if (!path || path.length < 2) {
                return;
            }

            // Get all elements connected to this path using the same logic as getNetworkElementsByNodes
            let pathElements = this.getNetworkElementsByPath(path);

            // Fallback: if no elements found via graph, try using selectedElements
            if (pathElements.length === 0) {
                pathElements = selectedElements;
            }

            if (pathElements.length === 0) {
                return;
            }

            // Build branch by including all elements found for this path
            let branchElements: (Line | Block | ElbowBlock | Tee)[] = [];
            let usedElementsInBranch = new Set<(Line | Block | ElbowBlock | Tee)>();

            // Add all path elements to the branch (they're already connected to the network)
            pathElements.forEach(element => {
                if (!usedElementsInBranch.has(element)) {
                    branchElements.push(element);
                    usedElementsInBranch.add(element);
                }
            });

            // Only add branch if it has elements
            if (branchElements.length > 0) {
                // Create Branch object
                const branch = new Branch();
                branch.id = `branch-${index}`; // Generate unique branch ID
                branch.path = path;
                branch.elements = branchElements;

                // Assign elements to this branch in their NetworkInfo
                branchElements.forEach(element => {
                    element.net.addToBranch(branch.id);
                });

                // Calculate end flow rate based on diffuser elements
                branch.calculateEndFlowRate();

                branches.push(branch);
            }
        });

        

        return branches;
    }

    /**
     * Get all network elements (including fittings) connected to a path of nodes
     * Uses the same logic as getNetworkElementsByNodes but for a specific path
     * 
     * IMPORTANT: This function filters elements to only include those that are actually
     * part of the path sequence, not just elements that share any node ID. This prevents
     * issues with Tee fittings where segments from both sides might be included.
     */
    private getNetworkElementsByPath(path: string[]): (Line | Block | ElbowBlock | Tee)[] {
        const displayedShapes = getDisplayedShapes();
        if (!displayedShapes) {
            return [];
        }

        let routeElements: (Line | Block | ElbowBlock | Tee)[] = [];

        // Find the graph that contains these nodes
        const graf = a.graphs.find(g => {
            for (const nodeId of path) {
                if (nodeId && g.hasNode(nodeId)) {
                    return true;
                }
            }
            return false;
        });

        if (!graf) {
            return [];
        }

        // Extract all IDs (including fitting IDs) using shared helper
        const uniqueIds = extractNodeIdsWithFittings(path, graf, a.graphs);
        
        // Create a set of path node IDs for quick lookup
        const pathNodeSet = new Set(path);

        // For each element, check if it connects consecutive nodes in the path
        for (const element of displayedShapes) {
            const networkElement = element as any;

            if (typeof networkElement.hasGraphNode !== 'function') {
                continue;
            }

            // Get crucial points of the element (start, end, mid)
            const crucialPoints = networkElement.getCrucialPoints?.();
            if (!crucialPoints) {
                continue;
            }

            // Check if element has any of the IDs (including fitting IDs)
            let hasMatchingId = false;
            for (const searchId of uniqueIds) {
                if (networkElement.hasGraphNode(searchId)) {
                    hasMatchingId = true;
                    break;
                }
            }

            if (!hasMatchingId) {
                continue;
            }

            // For Line segments: verify they connect consecutive nodes in the path
            // This prevents including segments from the "wrong" side of Tee fittings
            // The key insight: a branch path is a sequence of nodes, and Line segments
            // should only be included if they connect two consecutive nodes in that sequence
            if (networkElement instanceof Line) {
                const startId = crucialPoints.start?.id;
                const endId = crucialPoints.end?.id;
                
                if (!startId || !endId) {
                    continue;
                }
                
                // Strict check: line must connect two consecutive nodes in the path
                // This ensures we don't include segments from the "wrong" side of Tee
                let isInPath = false;
                for (let i = 0; i < path.length - 1; i++) {
                    const currentNodeId = path[i];
                    const nextNodeId = path[i + 1];
                    
                    // Check if line connects these consecutive nodes (in either direction)
                    if ((startId === currentNodeId && endId === nextNodeId) ||
                        (startId === nextNodeId && endId === currentNodeId)) {
                        isInPath = true;
                        break;
                    }
                }
                
                // If not found in consecutive check, verify through fitting child nodes
                // This handles cases where fittings create intermediate child nodes in the path
                if (!isInPath) {
                    // Check if line connects nodes that are in the path but separated by a fitting
                    // (e.g., parentNode -> childNode -> nextNode, where childNode is a fitting's child)
                    const startIndex = path.indexOf(startId);
                    const endIndex = path.indexOf(endId);
                    
                    // If both nodes are in path and are adjacent (within 1 position), include it
                    // This handles the case where a fitting's child node is in the path
                    if (startIndex !== -1 && endIndex !== -1 && Math.abs(startIndex - endIndex) === 1) {
                        isInPath = true;
                    }
                }
                
                if (isInPath) {
                    routeElements.push(networkElement);
                }
            } else {
                // For fittings (Block, ElbowBlock, Tee): include if they have matching IDs
                // Fittings are always included if they match, as they represent junction points
                routeElements.push(networkElement);
            }
        }

        return routeElements;
    }

    assignFlowDirectionInGraf(graf: Graf) {

        let checkIfFitting = (nodeId: string) => {
            let nodeAttrs = graf.getNodeAttributes(nodeId);
            if ('fittings' in nodeAttrs && Array.isArray(nodeAttrs.fittings) && nodeAttrs.fittings.some(f => f.elementKind !== 'Block')) {
                return true;
            }
            return false;
        }

        let moreOpenEnds = this.checkIfMoreThan1OpenEnds(graf);
        if (moreOpenEnds) {
            return;
        }

        let loops = getNetworkLoopsInGraf(graf);

        this.setOpenEndFlowDirectionsFromTerminals(graf, loops);
        this.updateOpenEndLabelsWithFlowDirections(graf);

        for (let i = 0; i < loops.length; i++) {
            const loop = loops[i];
            let isOpenEndOnStart = graf.getNodeAttribute(loop[0], 'isOpenEnd');
            let openEndIndex = isOpenEndOnStart ? 0 : loop.length - 1;
            let currentFlowDirection = graf.getNodeAttribute(loop[openEndIndex], 'flowDirection');

            // Determine traversal direction (forward or backward through the loop)
            const traverseForward = openEndIndex === 0;

            for (let j = 0; j < loop.length; j++) {
                // Get node index based on traversal direction
                const nodeIndex = traverseForward ? j : loop.length - 1 - j;
                const nodeId = loop[nodeIndex];

                // Skip open end nodes - they already have flow direction set
                const isOpenEnd = graf.getNodeAttribute(nodeId, 'isOpenEnd');
                if (isOpenEnd) {
                    // Open end node already has direction, but we need to get it for propagation
                    currentFlowDirection = graf.getNodeAttribute(nodeId, 'flowDirection');
                    continue;
                }

                // All other nodes are fitting nodes - set their flow direction
                const isFitting = checkIfFitting(nodeId);
                if (isFitting && currentFlowDirection) {
                    graf.setNodeAttribute(nodeId, 'flowDirection', currentFlowDirection);

                    // Flip flow direction for next nodes: IN -> OUT, OUT -> IN, UNKNOWN stays UNKNOWN
                    currentFlowDirection = currentFlowDirection === FlowDirection.IN
                        ? FlowDirection.OUT
                        : (currentFlowDirection === FlowDirection.OUT
                            ? FlowDirection.IN
                            : FlowDirection.UNKNOWN);
                }
            }
        }
    }

    /**
     * Sets flow direction for open ends based on terminals in each loop
     * @param graf - The graph
     * @param loops - Array of loops (each loop is an array of node IDs)
     */
    private setOpenEndFlowDirectionsFromTerminals(graf: Graf, loops: string[][]): void {
        loops.forEach(loop => {
            const terminalNodeId = this.findTerminalInLoop(graf, loop);
            const openEndNodeId = this.findOpenEndInLoop(graf, loop);
            
            if (terminalNodeId && openEndNodeId) {
                const terminalFlowDirection = graf.getNodeAttribute(terminalNodeId, 'flowDirection');
                if (terminalFlowDirection) {
                    graf.setNodeAttribute(openEndNodeId, 'flowDirection', terminalFlowDirection);
                }
            }
        });
    }

    /**
     * Finds terminal node in a loop
     * @param graf - The graph
     * @param loop - Array of node IDs representing a loop
     * @returns Terminal node ID or null
     */
    private findTerminalInLoop(graf: Graf, loop: string[]): string | null {
        for (const nodeId of loop) {
            const isTerminal = graf.getNodeAttribute(nodeId, 'isTerminal');
            if (isTerminal === true) {
                return nodeId;
            }
        }
        return null;
    }

    /**
     * Finds open end node in a loop
     * @param graf - The graph
     * @param loop - Array of node IDs representing a loop
     * @returns Open end node ID or null
     */
    private findOpenEndInLoop(graf: Graf, loop: string[]): string | null {
        for (const nodeId of loop) {
            const isOpenEnd = graf.getNodeAttribute(nodeId, 'isOpenEnd');
            if (isOpenEnd === true) {
                return nodeId;
            }
        }
        return null;
    }

    updateLabelsBasedOnFlowDirection(graf: Graf) {
        /**
         * for each node check flowDirection attribute, remove existing flow direction from the label
         * and assign new one based on the flowDirectionAttribute
         */
    }

    checkIfMoreThan1OpenEnds(graf: Graf): boolean {
        let nodes = graf.nodes();
        let openEndsCount = 0;
        for (const nodeId of nodes) {
            let isOpenEnd = graf.getNodeAttribute(nodeId, 'isOpenEnd');
            if (isOpenEnd === true) {
                openEndsCount++;
            }
        }

        if (openEndsCount > 1) {
            return true;
        }
        return false;
    }
}